import { Marker } from 'mapbox-gl';

class MapboxMarker {
  mounted = false;

  private _lng = 0;

  private _lat = 0;

  destroy = false;

  marker: Marker | null = null;

  updated = true;

  get lng(): number {
    return this._lng;
  }

  set lng(nextLng: number) {
    this._lng = nextLng;
    this.updated = true;
  }

  get lat(): number {
    return this._lat;
  }

  set lat(nextLat: number) {
    this._lat = nextLat;
    this.updated = true;
  }
}

export default MapboxMarker;
